import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import bannerImage from "../../Images/Banner/recognisation-banner.webp";
import classroomImage from "../../Images/gov-body/rules.webp";
import { Row } from "react-bootstrap";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import "../../Placement.css";
import acc from "../../Images/accrediations/iaou.webp"

const IAU = () => {
    return (
        <>
            <title>ISBM University – IAU Accredited & Globally Recognized</title>
            <meta
                name="description"
                content="ISBM University is a proud member of the International Association of Universities (IAU), a UNESCO-affiliated organization promoting global higher education collaboration."
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="conatiner-xxl">
                        <div className="section-hero-content">
                            <h1>International Association of Universities</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </a>
                                </li>
                                <li
                                    className="breadcrumb-item active text-white"
                                    aria-current="page"
                                >
                                    IAU
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section class="ptb-50">
                <div class="container-xxl">
                    <h2 class="section-title modern-title text-center text-blue">ISBM University – Proud Member of IAU</h2>
                    <p class="text-center mx-auto">Connecting with global higher education leaders through IAU.</p>

                    <div class="row g-4 mt-5">
                        <div class="col-12">
                            <div class="modern-health">
                                <div class="row g-0 h-100">
                                    <div class="col-md-6 order-md-1 position-relative">
                                        <div class="health-image-container">
                                            <div class="health-background-block bg-purple"></div>
                                            <img src={acc} alt="Sports Activities" class="health-image" />
                                        </div>
                                    </div>
                                    <div class="col-md-6 order-md-2">
                                        <p>ISBM University is a member of the International Association of Universities (IAU), a UNESCO-based organization promoting collaboration among leading universities worldwide. Through this membership, we ensure that our academic practices align with international education standards, opening opportunities for cross-border learning, research collaborations, and cultural exchange.</p>
                                        <h3 class="fw-bold mb-3">Key Highlights of IAU Membership</h3>

                                        <div class="health-highlights mb-3">
                                            <div class="health-highlight-item">
                                                <i class="ti ti-check"></i>Access to a global higher education network.
                                            </div>
                                            <div class="health-highlight-item">
                                                <i class="ti ti-check"></i> Opportunities for international academic partnerships.
                                            </div>
                                            <div class="health-highlight-item">
                                                <i class="ti ti-check"></i> Participation in global research and knowledge sharing.
                                            </div>
                                            <div class="health-highlight-item">
                                                <i class="ti ti-check"></i> Exposure to international best practices in education.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <Footer />
        </>
    );
};

export default IAU;
